import { useState, useEffect, useRef } from 'react';
// https://stackoverflow.com/a/45323523
export var useComponentVisible = function (initialIsVisible) {
    var _a = useState(initialIsVisible), isComponentVisible = _a[0], setIsComponentVisible = _a[1];
    var ref = useRef(null);
    var handleClickOutside = function (event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setIsComponentVisible(false);
        }
    };
    useEffect(function () {
        if (isComponentVisible) {
            document.addEventListener('click', handleClickOutside, true);
            return function () {
                document.removeEventListener('click', handleClickOutside, true);
            };
        }
    }, [isComponentVisible]);
    return { ref: ref, isComponentVisible: isComponentVisible, setIsComponentVisible: setIsComponentVisible };
};
